import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=d7166c94&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7166c94')) {
      api.createRecord('d7166c94', component.options)
    } else {
      api.reload('d7166c94', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=d7166c94&", function () {
      api.rerender('d7166c94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25526uOI11vNK/JS/comp/IncreaseNumber.vue"
export default component.exports